import { getHomeIdentity } from "../home/launch-oidc.js";

const HOME_FAVORITES_URL = "https://homefavorites-rqfgqadjxa-ez.a.run.app";

// Must match Firebase secret ZEP_APP_SECRET
const W2L_APP_SECRET = "yOL7/Xl3FsIHGYihibY+thG0MlTeezrqx3pONsvCODQ=";
const AVATAR_PLACEHOLDER = "https://placehold.co/32x32?text=?";

/** @type {{ myFavoriteIds: string[], byApp: Record<string, Array<object>> }} */
let cache = {
  myFavoriteIds: [],
  byApp: {},
};

function emptyPayload() {
  return { myFavoriteIds: [], byApp: {} };
}

function normalizePayload(data) {
  const myFavoriteIds = Array.isArray(data && data.myFavoriteIds)
    ? data.myFavoriteIds.filter((id) => typeof id === "string")
    : [];
  const byApp = {};
  const rawByApp = data && data.byApp && typeof data.byApp === "object" ? data.byApp : {};

  Object.keys(rawByApp).forEach((appId) => {
    const list = Array.isArray(rawByApp[appId]) ? rawByApp[appId] : [];
    byApp[appId] = list
      .filter((entry) => entry && entry.userId)
      .map((entry) => ({
        userId: String(entry.userId),
        nickname: entry.nickname || "عضو",
        avatarLink: entry.avatarLink || null,
        favoritedAt: entry.favoritedAt || null,
      }));
  });

  return { myFavoriteIds, byApp };
}

function setCache(payload) {
  cache = normalizePayload(payload);
  return cache;
}

async function postFavorites(body) {
  const res = await fetch(HOME_FAVORITES_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-W2L-Secret": W2L_APP_SECRET,
    },
    body: JSON.stringify(body),
  });

  const text = await res.text();
  let data = {};
  try {
    data = JSON.parse(text);
  } catch {
    data = {};
  }

  if (!res.ok || data.success !== true) {
    const message = data.message || data.error || "favorites_request_failed";
    throw new Error(message);
  }

  return data;
}

export function getFavoriteIds() {
  return cache.myFavoriteIds.slice();
}

export function isFavorite(appId) {
  if (!appId) return false;
  return cache.myFavoriteIds.includes(appId);
}

export function getFavoritedBy(appId) {
  if (!appId) return [];
  const list = cache.byApp[appId];
  return Array.isArray(list) ? list.slice() : [];
}

export function avatarUrlFor(entry) {
  if (entry && entry.avatarLink) return entry.avatarLink;
  return AVATAR_PLACEHOLDER;
}

/**
 * Load favorites for the current space member.
 * @return {Promise<{ myFavoriteIds: string[], byApp: Record<string, Array<object>> }>}
 */
export async function listFavorites() {
  const { userId, spaceId, nickname } = getHomeIdentity();
  if (!userId || !spaceId) {
    return setCache(emptyPayload());
  }

  const data = await postFavorites({
    action: "list",
    userId,
    spaceId,
    nickname: nickname || undefined,
  });

  return setCache(data);
}

/**
 * Toggle favorite for an app. Updates local cache from the server response.
 * @param {string} appId
 * @return {Promise<{ isFavorite: boolean, favoritedBy: Array<object>, myFavoriteIds: string[] }>}
 */
export async function toggleFavorite(appId) {
  if (!appId) {
    throw new Error("missing_app_id");
  }

  const { userId, spaceId, nickname } = getHomeIdentity();
  if (!userId || !spaceId) {
    throw new Error("missing_identity");
  }

  const data = await postFavorites({
    action: "toggle",
    userId,
    spaceId,
    appId,
    nickname: nickname || undefined,
  });

  setCache(data);

  return {
    isFavorite: data.isFavorite === true,
    favoritedBy: getFavoritedBy(appId),
    myFavoriteIds: getFavoriteIds(),
  };
}
